import { useState, useEffect } from "react";

function useDevice() {
  const [device, setDevice] = useState(() =>
    window.innerWidth > 1279 ? "desktop" : "mobile"
  );

  useEffect(() => {
    const updateDevice = () => {
      setDevice(window.innerWidth > 1279 ? "desktop" : "mobile");
    };

    window.addEventListener("resize", updateDevice);
    return () => window.removeEventListener("resize", updateDevice);
  }, []);

  return device;
}

export default useDevice;
